<mat-toolbar class="text-uppercase">
  <mat-toolbar-row>
    <span>Histórico de exceções de cutoff</span>
  </mat-toolbar-row>
</mat-toolbar>

<mat-card>
  <mat-card-header></mat-card-header>
  <mat-card-content class="container-fluid">
    <div class="row mb-2">
      <div class="col-4">
        <label>Tipo de Cutoff</label>
        <ng-select
          [clearSearchOnAdd]="true"
          [items]="cutoffTypeListToFilter"
          bindLabel="description"
          bindValue="id"
          [(ngModel)]="cutoffTypeSelected"
          [ngModelOptions]="{ standalone: true }"
          (change)="applyFilter()"
        >
          <ng-option
            *ngFor="let item of cutoffTypeListToFilter"
            [value]="item"
            >{{ item.description }}</ng-option
          >
        </ng-select>
      </div>
      <div class="col-4">
        <label>Gestora</label>
        <ng-select
          [clearSearchOnAdd]="true"
          [items]="accountManagerListToFilter"
          bindLabel="name"
          bindValue="id"
          [(ngModel)]="accountManagerSelected"
          [ngModelOptions]="{ standalone: true }"
          (change)="applyFilter()"
        >
          <ng-option
            *ngFor="let item of accountManagerListToFilter"
            [value]="item"
            >{{ item.document }} {{ item.name }}</ng-option
          >
        </ng-select>
      </div>
      <div class="col-4">
        <label>Fundo</label>
        <ng-select
          [clearSearchOnAdd]="true"
          [items]="fundListToFilter"
          bindLabel="name"
          bindValue="id"
          [(ngModel)]="fundSelected"
          [ngModelOptions]="{ standalone: true }"
          (change)="applyFilter()"
        >
          <ng-option *ngFor="let item of fundListToFilter" [value]="item"
            >{{ item.document }} {{ item.name }}</ng-option
          >
        </ng-select>
      </div>
    </div>
  </mat-card-content>
</mat-card>

<table mat-table [dataSource]="cutoffHistoryFilteredList" class="hours">
  <ng-container matColumnDef="creationDate">
    <th mat-header-cell *matHeaderCellDef>Data</th>
    <td mat-cell *matCellDef="let item">
      {{ item.creationDate | date: "dd/MM/yyyy HH:mm" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="creationUser">
    <th mat-header-cell *matHeaderCellDef>Usuário</th>
    <td mat-cell *matCellDef="let item">{{ item.creationUser }}</td>
  </ng-container>

  <ng-container matColumnDef="cutoffType">
    <th mat-header-cell *matHeaderCellDef>Tipo de Cutoff</th>
    <td mat-cell *matCellDef="let item">
      {{ item.ticketCutoffType.description }}
    </td>
  </ng-container>

  <ng-container matColumnDef="accountManagerName">
    <th mat-header-cell *matHeaderCellDef>Gestora</th>
    <td mat-cell *matCellDef="let item">{{ item.accountManagerName }}</td>
  </ng-container>

  <ng-container matColumnDef="fundName">
    <th mat-header-cell *matHeaderCellDef>Fundo</th>
    <td mat-cell *matCellDef="let item">{{ item.fundName }}</td>
  </ng-container>

  <ng-container matColumnDef="defaultLimitTime">
    <th mat-header-cell *matHeaderCellDef>Horário Limite</th>
    <td mat-cell *matCellDef="let item">
      <span [class.out-of-vigor]="item.timeLimit">
        {{ item.timeLimit | date: "HH:mm":"-0300" }}
      </span>
    </td>
  </ng-container>

  <ng-container matColumnDef="justificative">
    <th mat-header-cell *matHeaderCellDef>Justificativa</th>
    <td mat-cell *matCellDef="let item">{{ item.justificative }}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
